<ng-container *ngFor="let row of searchResults$ | async">
  <div class="search-results-container" data-test-id="search-result-element">
    <div class="section-title-wrapper">
      <div class="section-title">{{ row.collectionName | localize }}</div>
    </div>
    <ul class="list" [attr.data-test-id]="row.collectionName">
      <li class="section-list item-row" *ngFor="let item of row.items; index as i">
        <search-item class="selection-list" *ngIf="i < itemsLimit" [item]="item"></search-item>
      </li>
    </ul>
    <div class="result-actions" *ngIf="row.totalCount > itemsLimit">
      <button
        *ngIf="currentFacet === 'everywhere'; else nonEverywhere"
        [attr.data-test-id]="'view-all-results-for-' + row.collectionName"
        (click)="viewMoreResults(row.collectionName); $event.stopPropagation()"
        ui-button
        uiType="link">
        {{ "view_more_results" | localize }} ({{ row.totalCount }})
      </button>
      <ng-template #nonEverywhere>
        <button [attr.data-test-id]="'view-all-results-for-' + row.collectionName" (click)="viewAllResults(row.collectionName)" ui-button uiType="link">
          {{ "view_all_results" | localize }} ({{ row.totalCount }})
        </button>
        <button [attr.data-test-id]="'search-everywhere-from-' + row.collectionName" (click)="changeFacetToEverywhere(); $event.stopPropagation()" ui-button uiType="link">
          {{ "or_search_everywhere" | localize }}
        </button>
      </ng-template>
    </div>
  </div>
  <ui-divider class="sp-mb-0 sp-mt-0" *ngIf="currentFacet === 'everywhere'" uiType="horizontal"></ui-divider>
</ng-container>
